import { useState } from "react";
import FirstStep from "../../components/intro/firstStep";
import SecondStep from "../../components/intro/secondStep";
import ThirdStep from "../../components/intro/thirdStep";

const Intro = () => {
  const [step, setStep] = useState(1);

  return (
    <div className="h-full">
      {step === 1 ? (
        <FirstStep setStep={setStep} />
      ) : step === 2 ? (
        <SecondStep setStep={setStep} />
      ) : (
        <ThirdStep />
      )}
    </div>
  );
};

export default Intro;
